import { TypeOfContainement } from "@/models/settings.model";
import {
  BigVolumeCalculator,
  ICalculator,
  LowerBoundCalculator,
} from "@/services/iCalculatorParameters.service";

const calculator1: ICalculator = new LowerBoundCalculator({
  constantValue: 3.3,
  lowerBound: 80.0,
  computeValue(volume): number {
    return 5.504 * Math.exp(-0.01103 * volume) + 0.9895 * Math.exp(-0.0009817 * volume);
  },
});

const calculator2: ICalculator = new LowerBoundCalculator({
  constantValue: 5.1,
  lowerBound: 80.0,
  computeValue(volume): number {
    return 1.086 * Math.exp(-0.003829 * volume) + 4.256 * Math.exp(-0.00006473 * volume);
  },
});

const calculator3: ICalculator = new LowerBoundCalculator({
  constantValue: 17.3,
  lowerBound: 95.0,
  computeValue(volume): number {
    return 22.16 * Math.exp(-0.009987 * volume) + 9.62 * Math.exp(-0.001033 * volume);
  },
});

const calculator4: ICalculator = new LowerBoundCalculator({
  constantValue: 36.1,
  lowerBound: 89.0,
  computeValue(volume): number {
    return 18.47 * Math.exp(-0.00478 * volume) + 24.15 * Math.exp(-0.0001464 * volume);
  },
});
const calculatorBigVolume: ICalculator = new BigVolumeCalculator();

const map = new Map<TypeOfContainement, ICalculator>([
  [TypeOfContainement.TypeI, calculator1],
  [TypeOfContainement.TypeII, calculator2],
  [TypeOfContainement.TypeIII, calculator3],
  [TypeOfContainement.TYPEIV, calculator4],
]);

/**
 * Calculate Leak Rate
 */
export function estimedLeakRate(
  totalVolume: number,
  typeOfContainment: TypeOfContainement
): number {
  let calculator;

  if (typeOfContainment === TypeOfContainement.TYPEIV && totalVolume > 2500) {
    calculator = calculatorBigVolume;
  } else {
    calculator = map.get(typeOfContainment);
    if (!calculator) {
      return 0;
    }
  }

  return calculator.compute(totalVolume);
}

/**
 * Determine if the leakrate is an extrapolation (outside of graph in specification) or precise
 * @returns true if it's precise, false if it's an extrapolation
 */
export function isLeakRatePrecise(
  totalVolume: number,
  typeOfContainment: TypeOfContainement
): boolean {
  if (typeOfContainment === TypeOfContainement.TYPEIV) {
    return true;
    //Type 3 is outside of the graph starting from 500
  } else if (typeOfContainment === TypeOfContainement.TypeIII && totalVolume > 500) {
    return false;
    //Type 1 and Type 2 are outside of the graph starting from 2500
  } else if (totalVolume > 2500) {
    return false;
  } else {
    return true;
  }
}

/**
 * check if leakRate value is outside of acceptable deviation
 * @param leakRate input leak rate
 * @param calculatedLeakRate estimed leak rate
 * @param maximumDeviation maximum acceptable difference
 * @returns true if the difference is more than the maximum deviation acceptable
 */
export function isOutsideOfDeviation(
  leakRate: number,
  calculatedLeakRate: number,
  maximumDeviation: number
): boolean {
  return Math.abs(leakRate - calculatedLeakRate) > maximumDeviation;
}
